// libraries
import { Typography } from '@interstate/components/Typography';

// styles
import { StyledRepairOrderField } from './RepairOrders.style';

export type RepairOrderFieldUIProps = {
    label: string;
    value: string;
    'data-testid'?: string;
};

export const RepairOrderFieldUI = ({ label, value, 'data-testid': dataTestId }: RepairOrderFieldUIProps) => (
    <StyledRepairOrderField data-testid={dataTestId}>
        <Typography tag="span" variant="body-xs" color="sem.color.on-surface.default">
            {label}:
        </Typography>
        <Typography tag="span" variant="body-sm" color="sem.color.on-surface.default">
            {value}
        </Typography>
    </StyledRepairOrderField>
);

export default RepairOrderFieldUI;
